import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { ButtonModule } from '../../components/atoms/button/button.module';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { LoadingModule } from '@app/components/molecules/loading/loading.module';
export const routerConfig = [
  {
    path: '',
    component: LoginComponent,
  },
];

@NgModule({
  declarations: [LoginComponent],
  exports: [LoginComponent],
  imports: [
    CommonModule,
    ButtonModule,
    LoadingModule,
    RouterModule,
    MatIconModule,
    RouterModule.forChild(routerConfig),
  ],
})
export class LoginModule {}
